
















































/** @format */

import { Component, Mixins, Watch, Vue } from 'vue-property-decorator';
// @ts-ignore hack
import { configureInfo, configureEdit } from '@/api/system-management/index';
import ManualToWrangle from './components/index.vue';

export interface IForm {
  renewChangePackage: string; //固定车辆续费是否可变更套餐：00 否 01 是
}
// @Component({})
@Component({
  name: 'PlatformBussinesConfig',
  components: { ManualToWrangle }
})
export default class PlatformBussinesConfig extends Vue {
  isDisabled: boolean = true;
  spining: boolean = false;
  id: string = '';
  form: any = null;
  //保存
  handleEditSubmit(e: { stopPropagation: () => void; preventDefault: () => void }) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: any) => {
      if (!err) {
        // console.log('wuwuwuwuw')
        this.spining = true;
        this.updateData({ ...values });
      }
    });
  }
  //更新数据
  async updateData(values: any) {
    try {
      const res = await configureEdit({ ...values, id: this.id });
      this.$message.success('保存成功');
      this.initData();
      this.isDisabled = true;
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.spining = false;
    }
  }
  handleclick() {
    this.isDisabled = false;
  }
  //取消
  handleResetData() {
    this.initData();
    this.isDisabled = true;
  }

  //初始化表单
  initForm(values: { id: string; renewChangePackage: any }) {
    this.id = values.id ? values.id : '';
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          renewChangePackage: this.$form.createFormField({
            value: values.renewChangePackage ? values.renewChangePackage : ''
          })
        };
      }
    });
  }
  //数据初始化
  async initData() {
    try {
      const { data } = await configureInfo();
      console.log(data);
      this.initForm(data);
    } catch (e) {
      console.log(e);
    }
  }
  //
  created() {
    this.initData();
  }
}
